import { FC, useState } from "react";
import { Link } from "react-router-dom";
import {
  hasUsableMerchantLogo,
  MerchantListItem,
} from "../../hooks/useMerchants";
import { normalizeStorageUrl } from "../../helpers/assetUrl";

const MerchantItem: FC<{
  merchant: MerchantListItem;
}> = ({ merchant }) => {
  const productCount = merchant.product_count ?? 0;
  const businessName = merchant.business_name || "Unnamed merchant";
  const [logoFailed, setLogoFailed] = useState(false);
  const logoSrc = normalizeStorageUrl(merchant.logo);
  const hasLogo = hasUsableMerchantLogo(merchant.logo) && !logoFailed;

  if (!hasLogo) {
    return null;
  }

  return (
    <Link
      to={`/marketplace/merchants/${merchant.id}`}
      className="flex flex-col gap-2 p-2 rounded-md hover:bg-white hover:drop-shadow-md transition-all duration-300 cursor-pointer"
    >
      <div className="bg-zinc-100 aspect-square w-full rounded-md overflow-hidden">
        <img
          src={logoSrc}
          alt={businessName}
          onError={() => {
            setLogoFailed(true);
          }}
          className="w-full h-full aspect-square object-cover hover:scale-105 duration-500"
        />
      </div>
      <div className="flex flex-col gap-1">
        <div className="font-medium line-clamp-2">
          {businessName}
        </div>
        {merchant.acronym && (
          <div className="text-sm text-gray-500 line-clamp-1">
            {merchant.acronym}
          </div>
        )}
        <div className="font-medium">
          {productCount} {productCount === 1 ? "product" : "products"}
        </div>
      </div>
    </Link>
  );
};

export default MerchantItem;
